import { DialogContentTextProps as MUIDialogContentTextProps } from '@mui/material'

export type DialogContentTextProps = MUIDialogContentTextProps
